// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609172328/js/" + chunkId + "." + {"44":"38525f71","225":"7f7896c9","481":"c8350dc5","486":"a3622070","770":"1098c185"}[chunkId] + ".0.7170330950941672.chunk.js";
};